import { DotLottie } from '@lottiefiles/dotlottie-web'

export default class LottieAnimator {
    constructor() {
        this.lottieElements = document.querySelectorAll('.js-lottie-container')
        this.observer()
    }

    observer() {
        const options = {
            root: null,
            threshold: 0.5,
        }
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                const lotti = entry.target
                if (entry.isIntersecting && !lotti.classList.contains('run')) {
                    this.createNewLottie(entry.target)
                }
            })
        }, options)

        this.lottieElements.forEach((lottieElement) => {
            observer.observe(lottieElement)
        })
    }

    createNewLottie = (lottieElement) => {
        lottieElement.classList.add('run')

        new DotLottie({
            autoplay: true,
            loop: false,
            canvas: lottieElement,
            src: lottieElement.dataset.publicUrl,
            layout: {
                fit: lottieElement.dataset.layoutFit ? lottieElement.dataset.layoutFit : 'contain',
                // align is not needed because we align the canvas via css. but the align property is needed from the layout object to work
                align: [0, 0],
            },
        })
    }
}
